export function fadeInFunc() {
  const options = {
    root: null,
    threshold: 0
  };

  const callback = (function (changes) {
    for (let change of changes) {
      let target = change.target;
      if (change.isIntersecting) {
        target.classList.add('is-show');
      }
    }
  });

  const observer = new IntersectionObserver(callback, options);

  const targets = document.querySelectorAll('.js-fade')
  for (let target of targets) {
    observer.observe(target)
  }
}

/** スクロール一時禁止 **/
//let scroll_control = function (e) {
//  e.preventDefault();
//}
//export function no_scroll() {
//  document.addEventListener("mousewheel", scroll_control, {
//    passive: false
//  });
//  document.addEventListener("touchmove", scroll_control, {
//    passive: false
//  });
//}
//export function return_scroll() {
//  document.removeEventListener("mousewheel", scroll_control, {
//    passive: false
//  });
//  document.removeEventListener('touchmove', scroll_control, {
//    passive: false
//  });
//}

const keys = {
  37: 1,
  38: 1,
  39: 1,
  40: 1
};

function preventDefault(e) {
  e = e || window.event;
  if (e.preventDefault) {
    e.preventDefault();
    e.returnValue = false;
  }
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

const userAgent = window.navigator.userAgent.toLowerCase();

export function no_scroll() {
  if (window.addEventListener) { // older FF
    window.addEventListener('DOMMouseScroll', preventDefault, false);
    document.addEventListener("mousewheel", preventDefault, {
      passive: false
    });
    document.addEventListener("touchmove", preventDefault, {
      passive: false
    });
    document.onkeydown = preventDefaultForScrollKeys;
    if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
      window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    } else if (userAgent.indexOf('edge') != -1) {
      window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    } else if (userAgent.indexOf('chrome') != -1) {} else if (userAgent.indexOf('safari') != -1) {} else if (userAgent.indexOf('firefox') != -1) {
      window.onwheel = preventDefault; // modern standard
    } else if (userAgent.indexOf('opera') != -1) {}
  }
}

export function return_scroll() {
  if (window.removeEventListener) {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    document.removeEventListener("mousewheel", preventDefault, {
      passive: false
    });
    document.removeEventListener("touchmove", preventDefault, {
      passive: false
    });
    document.onkeydown = null;
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
  }
}

//高さ統一
//elm 高さを合わせる要素の共通クラス
//num 一列に並ぶ要素の数

export function equalBoxHeight(elm, num) {
  elm = $(elm);
  elm.css("height", "auto");
  elm.each(function (i) {
    let height;
    let $this = $(this);
    if (i === 0 || i % num === 0) {
      height = $this.height();
      for (let n = i + 1; n <= i + num - 1; n++) {
        if (height < elm.eq(n).height()) {
          height = elm.eq(n).height();
        }
      }
      for (let n = i; n <= i + num - 1; n++) {
        elm.eq(n).css("height", height + "px");
      }
    }
  });
}

//使用例
//function synopsisCardHeight() {
//  const breakPoint = 750;
//  if (breakPoint < window.innerWidth) {
//    equalBoxHeight('.synopsisCardVisual', 4);
//  } else {
//    equalBoxHeight('.synopsisCardVisual', 2);
//  }
//}
